// extracted by mini-css-extract-plugin
export default {"label":"ExhibitionDetailModal_label__NmPDA"};